module.exports = __webpack_public_path__ + "static/media/menu-icon.0087f44e.svg";